import { mapState, mapMutations, mapActions } from 'vuex';
import { required, numeric, email } from 'vuelidate/lib/validators';
import * as savedSearchAPI from '../../api/saved-search';
import { defaultZoomLevels } from '@vue/components/google-maps/constants/mapSettings';
import * as googlePlacesAPI from '../../api/google-places';
import { getGoogleAPILocationType, handleAPIErrors } from '../store/helpers';

// const validations = {
//     savedPropertySearchTitle: {required},
//     searchParams: {}
// };

// PROPERTY_SEARCH_FIELD_TYPES.float.map(fieldName => {
//     validations.searchParams[fieldName] = {numeric};
// });
// PROPERTY_SEARCH_FIELD_TYPES.int.map(fieldName => {
//     validations.searchParams[fieldName] = {numeric};
// });

export default {
  data(){
    return {
      // fieldTypes: PROPERTY_SEARCH_FIELD_TYPES,
      storingSavedPropertySearch: false
    };
  },
  computed: {
    ...mapState('propertySearchStore', [
      'savedPropertySearch',
    ]),  

    savedPropertySearchTitle: {
      get(){
        return this.savedPropertySearch.title;
      },
      set(title){
        // console.log(title);
        this.updateSavedPropertySearch({title});
      }
    }
  },
  validations(){


    let validations = {
      savedPropertySearchTitle: {required},
      searchParams: {
        location_txt: { required },
        min_asking_price: { numeric },
        max_asking_price: { numeric }
      }
    };

    if(this.isResidentWatchlist) {
      validations = {
        searchParams: {
          location_txt: { required },
        },
        contactForm: {
          first_name: { required },
          last_name: { required },
          email: { required, email },
          phone: { required },
        }
      }
    }
    
    return validations;
  },
  methods: {

    confirmSelectedZipcodesRemoval(){
      return new Promise((resolve, reject) => {
        swal(
          {
            icon: 'warning',
            title: 'Warning',
            text: 'You currently have zipcodes selected. Changing the location of this search will clear them. Continue?',
            buttons: {
              reject: {
                text: 'Cancel',
                value: 'cancel',
                className: 'bg-light text-dark',
              },
              continue: {
                text: 'Continue',
                value: 'continue',
              }
            },
          })
          .then(value => {
            switch (value) {

            case 'continue':
              resolve(value);
              return true;

            case 'cancel':
              reject(value);
              return false;
            }
          });
      });
    },

    /**
     * Update store with new selected location
     * @param {string} selection A string that is in the format of the RW Location Code (loc_cd) {{location_level}}-{{location_id}}
     */
    locationChangeRequest(selection){

      const isSearch = this.appName == 'property-search-app';
      const isAgentWebsite = this.appName == 'agent-websites-app';
      const doMapActions = isSearch || isAgentWebsite;

      return new Promise ((resolve, reject) => {

        googlePlacesAPI.getPlacesDetails({ placeId: selection.place_id })
          .then(res => {
            let locationText = selection.description;
            let coords = res.data.result.geometry.location;
            // console.log(res);
            // console.log('');
            // console.log('Google Places coordinates:', coords);
            // console.log('');
            let zoomLevel = false;

            /**
             * Get the zoom level
             */
            if(
              res.data && 
              res.data.result && 
              res.data.result.address_components && 
              Array.isArray(res.data.result.address_components)) {

              let locationLevel = getGoogleAPILocationType(res.data.result);
              let fallbackZoomLevel = 15;

              zoomLevel = defaultZoomLevels[this.searchType][locationLevel];
              
              if(!zoomLevel) {
                console.error('');
                console.error('No zoom level was found for given search. default of ' + fallbackZoomLevel + ' was applied');
                console.error('');
                zoomLevel = fallbackZoomLevel;
              }

              if(doMapActions) this.updateMapConfigZoom(zoomLevel);

            }

            this.updateSelectedLocation(res);

            if(doMapActions) {
              this.updateMapConfigCenter({
                lat: parseFloat(coords.lat),
                lng: parseFloat(coords.lng)
              });
            }

            if(isSearch){
              this.changePageTitle({locationText, searchType: this.searchParams.searchType});
            }
            

            this.changeSearchParams(
              {
                loc_cd: location.id,
                lat: parseFloat(coords.lat),
                lng: parseFloat(coords.lng),
                selected_zipcodes: [],
                location_txt: locationText,
                zoom: zoomLevel
              })
              .then(response => {
                resolve();
                // this.updateLocationChanging(false);
              });

            return false;
          })
          .catch(err => {
            console.warn(err);

            /**
            * Come back to this
            */
            // this.updateLocationChanging(false);
            reject();
          });

      });
      
    },
        
    /**
    * Handler for Selected Location changes. Checks to see if selected zipcodes exist, and if so goes thru the confirmation flow to prevnet them from accidentally being removed
    * @param {string} location A string that is in the format of the RW Location Code (loc_cd) {{location_level}}-{{location_id}}
    */
    onLocationSelectChange(location){

      /**
      * Come back to this
      */
      // this.updateLocationChanging(true);
            
      if(!this.searchParams.selected_zipcodes.length){
        this.locationChangeRequest(location);
      } else {
        this.confirmSelectedZipcodesRemoval()
          .then((value) => {
            this.locationChangeRequest(location);
          })
          .catch((value) => {

            /**
            * Come back to this
            */
            // this.updateLocationChanging(false);
            if(value == 'cancel'){
              /** 
               * This is used to trigger a change event on the location search dropdown - reverting the selection they made that they just cancelled out of
               */
              // this.updateSearchParams({loc_cd: this.searchParams.loc_cd});
            } else {
              console.warn('Unhandled error :: location select change');
            }
          });
      }
            
    },
        

    /*
    --  On Save Search --
    */
    onSaveSearch(){

            
      return new Promise((resolve, reject) => {
                
        try {
          const vm = this;

          if(!vm.selected_user){ console.warn('onSaveSearch failed -- invalid selected_user id: ', vm.selected_user); return false; }

          const userId = vm.selected_user;

          let apiAction = 'store';

          // prevent double clicks on the submit button
          this.storingSavedPropertySearch = true;

          // check the form fields against validation
          vm.$v.$touch();

          // if any of the form fields are invalid
          if (vm.$v.$invalid) { 
            console.warn('Invalid save search request');
            this.storingSavedPropertySearch = false;
            window.scrollDashboardToTop();
            reject({response: 'Invalid Form'});
            return false;
          }


          const generalFields = {
            title: this.savedPropertySearch.title,
            search_type: this.searchType
          };

          let requestParams = {
            userId,
            params: {
              ...generalFields,
              ...this.searchParams
            }
          };

          /* if editing a saved search, configure request for an update */
          if( this.appName == 'saved-property-search-manage-app' && this.manageType == 'edit'){
            apiAction = 'update';
            requestParams.id = this.savedPropertySearch.id;
          } else if( this.searchParams.ss ) {
            apiAction = 'update';
            requestParams.id = this.searchParams.ss;
          }

          // console.log(requestParams);
          // return false;

          savedSearchAPI[apiAction](requestParams)
            .then(({status, data}) => {

              let savedPropertySearch = data;
              
              if($('#store-saved-property-search-modal')){
                $('#store-saved-property-search-modal').modal('hide');
              }
              if(status == 201 || status == 200) {
                                
                window.sendClickEvent({
                  category: 'Behavior Tracking - Search - Saved Search',
                  action: apiAction == 'store' ? 'Create' : 'Update'
                });
                                
                if(vm.appName == 'property-search-app'){
                  
                  /**
                   * Request was submitted from the SEARCH page
                   */
                  swal({
                    icon: 'success',
                    title: 'Property Search Saved',
                    text: 'Your property search has been saved successfully. Remember to click Update if you make any changes.'
                  });

                  vm.loadSavedSearch(savedPropertySearch);
                  
                  
                } else {
                  
                  /**
                   * Request was submitted from the SAVED SEARCH MANAGER page */     
                                    
                  let redirectUrl = false;

                  if(vm.manageMode == 'user') {
                    redirectUrl = '/saved-searches';

                  } else if(vm.manageMode == 'manage'){
                    redirectUrl = `/user/${userId}/saved-searches`;
                  }

                  redirectUrl += `?search_type=${savedPropertySearch.search_type}`
                                    
                  sweetAlert({
                    icon: 'success',
                    title: 'Property Search Saved', 
                    text: 'Redirecting to Saved Searches...',
                    buttons: [false, 'Continue']
                  }).then(() => {
                    window.location = redirectUrl;
                  });
                  setTimeout(() => {
                    window.location = redirectUrl;
                    // window.location = `${vm.baseURL}/buyer/${vm.selected_user}/saved-searches`;
                  }, 4000);
                }
                vm.storingSavedPropertySearch = false;
              } else {
                console.warn('Unahndled store saved property search response');
                vm.storingSavedPropertySearch = false;
              }
              resolve({data});
            })
            .catch(err => {
              // .catch(({response: {status, statusText, data:{message}}}) => {
              vm.storingSavedPropertySearch = false;
              handleAPIErrors(err);
              reject(err.response);
            });

        } catch(e){
          reject(e);
        }

      });

            

    },
        
    onSearchTypeChange(searchType){
      const vm = this;
      this.changeSearchType({searchType})
        .then(() => {
          if(vm.appName == 'property-search-app'){
            vm.changeSearchParams({
              min_asking_price: '', 
              max_asking_price: '',
              order_by: '',
              page: 1
            }).then(() => {
              this.changePageTitleNoLocation(searchType);
              vm.loadNewProperties({});
            });
          }
        })
        .catch(err => {
          console.lwarn(err);
        });
    },

    ...mapMutations('propertySearchStore', [
      'updateSearchParams'
    ]),
    ...mapActions('propertySearchStore', [
      'loadSavedSearch'
    ]),
    
        
  }
};